import { style } from 'typestyle'
export const mr40 = style({ marginRight: '40px' })
